import React from "react";

const Helmet = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M22.75 15.838v7.266l9.893 4.948a.937.937 0 0 0 1.357-.84v-9.968l-11.25-1.406Zm-2.696-.337c-.585-.056-1.054.373-1.054.93v4.218c0 .358.199.68.518.839l1.357.678v-6.563l-.821-.102Z"
            fill={fill}
        />
        <path className="u_fill"
            fill={fill}
            d="M17.125 20.65V16.43a2.814 2.814 0 0 1 3.161-2.791l13.577 1.698c-.72-4.2-3.163-8.1-6.825-10.556-3.977-2.669-9.001-3.465-13.674-2.182C7.133 4.31 2 11.281 2 17.985v4.49c0 1.1.647 2.106 1.678 2.575l20.703 8.536a5.4 5.4 0 0 0 7.103-3.026c.1-.25.205-.56.308-.837L18.68 23.165a2.813 2.813 0 0 1-1.555-2.516Zm-7.563 2.096a3.754 3.754 0 0 1-3.75-3.75 3.754 3.754 0 0 1 3.75-3.752 3.754 3.754 0 0 1 3.75 3.751 3.754 3.754 0 0 1-3.75 3.75Z"
        />
        <path className="u_fill"
            fill={fill}
            d="M9.563 17.12a1.878 1.878 0 0 0-1.876 1.875c0 1.034.842 1.875 1.875 1.875a1.878 1.878 0 0 0 1.876-1.875 1.878 1.878 0 0 0-1.876-1.875Z"
        />
    </svg>
);

export default Helmet;